// extracted by mini-css-extract-plugin
export default {"not-found":"NotFount_not-found__g61oM"};